import React, { useState, useEffect } from "react";
import { loader } from "../redux/type";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Tab from "react-bootstrap/Tab";
import { useTranslation } from "react-i18next";
import Tabs from "react-bootstrap/Tabs";
import OtpInput from "react-otp-input";
import SideNavbar from "./SideNavBar";
import { Nav, Navbar, NavDropdown } from "react-bootstrap";
import SideBar from "./SideBar";
import { LoginUser } from "../Services/authServices";
import { sendOtpMobile } from "../Services/getServices";
import { verifyMobileOtp } from "../Services/getServices";
import { auth } from "../redux/type";
import { toast } from "react-toastify";
import OtpTimer from "otp-timer";
import { LoginDepartmentUser } from "../Services/authServices";
import { verifyLoginOtp } from "../Services/postServices";
import { multipleUserOtp } from "../Services/postServices";
import { AesUtil } from "../Services/encryptionDecryption";
import { loggedInUserDetails } from "../Services/postServices";
const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  //   const aes = new AesUtil();
  // console.log(aes.encrypt('123123'));
  // console.log(aes.decrypt('U2FsdGVkX1/zgsyDpOT+Hf8YHQkiJ3q/CoIqvT1XgNg='));

  var [user, setUser] = useState("0");
  var [otpBut, setOtpBut] = useState("0");
  var [dDAOtp, setDDAOtp] = useState("0");
  var [ssoUserId, setSsoUserId] = useState("");
  var [ssoUserPass, setSsoUserPass] = useState("");
  var [ssoDeptId, setSsoDeptId] = useState("");
  var [ssoDeptPass, setSsoDeptPass] = useState("");
  var [ssoUserMobileNumber, setSsoUserMobilenumber] = useState("");
  const [otp, setOtp] = useState("");
  const dispatch = useDispatch();

  // console.log("ssoUserMobileNumber=", ssoUserMobileNumber.toString());
  function sendUserDetails(req3){

    loggedInUserDetails(req3,(res)=>{
  
  if(res?.data?.status){
  
  
  }else{
  
  }
  
    })
  
  
  }

  function submitSsoLogin() {
    dispatch({ type: loader.startLoader });
    LoginUser(ssoUserId, ssoUserPass, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        toast.success(res?.data?.message);
        let req7={
          "loginedUserName":ssoUserId,
    "loginedUserType":"Citizen"
        }
        sendUserDetails(req7);

        if (
          res?.data?.userdetail?.domainCodesByUserId[0]?.userTypeName === "N/A" 
        ) {
          localStorage.setItem("userType", 0);
          localStorage.setItem("token", res?.data?.token);

          dispatch({
            type: auth.login,
            payload: res?.data?.userdetail,
          });
          navigate("/citizendashboard");
          window.location.reload();
        } else {
          toast.error("Login With DDA Official");
        }
      } else {
        toast.error(res?.message);
      }
    });
  }

  const loginThroughOtp = (e) => {
    e.preventDefault();

    dispatch({ type: loader.startLoader });

    verifyLoginOtp(ssoUserMobileNumber, otp, userId2, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        toast.success(res?.data?.message);

        if (
          res?.data?.userdetail?.domainCodesByUserId[0]?.userTypeName === "N/A"
        ) {
          localStorage.setItem("userType", 0);
          localStorage.setItem("token", res?.data?.token);

          dispatch({
            type: auth.login,
            payload: res?.data?.userdetail,
          });
          navigate("/citizendashboard");
          window.location.reload();
        } else {
          toast.error("Login With DDA Official");
        }
      } else {
        toast.error(res?.message);
      }
    });
  };


  function submitDepartmentSsoLogin() {
    dispatch({ type: loader.startLoader });
    LoginDepartmentUser(ssoDeptId, ssoDeptPass, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        // localStorage.setItem("userType", 1);

        if (
          (res?.data?.userdetail?.domainCodesByUserId[0]?.userTypeName ===
            "N/A") |
          (res?.data?.userdetail?.domainCodesByUserId[0]?.userTypeName === null)
        ) {
          toast.error("Login through Citizen Login");
          return;
        }

        let req7={
          "loginedUserName":ssoDeptId,
    "loginedUserType":"Admin"
        }
        sendUserDetails(req7);
        toast.success(res?.data?.message);
        localStorage.setItem("token1", res?.data?.token);
        let obj1 = res?.data?.userdetail;
        const myJSON = JSON.stringify(obj1);

        localStorage.setItem("user1", myJSON);
        // dispatch({
        //   type: auth.login,
        //   payload: res?.data?.userdetail,
        // });
        navigate("/switchuser");
        // window.location.reload();
      } else {
        toast.error(res?.message);
        // toast.error("Unauthorized User")
      }
    });
  }

  const [loginByOtp, setLoginByOtp] = useState(null);
  // console.log("LOGINGG=",loginByOtp)
  const [userId2, setUserId2] = useState("");

  const [secondsLeft, setSecondsLeft] = useState(180);
  const [timerStarted, setTimerStarted] = useState(false);
  const [showFinalButton, setShowFinalButton] = useState(false);

  useEffect(() => {
    let interval;

    if (timerStarted) {
      interval = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev <= 1) {
            clearInterval(interval);
            setShowFinalButton(true);
            setTimerStarted(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }

    return () => clearInterval(interval);
  }, [timerStarted]);

  const formatTime = (secs) => {
    const minutes = Math.floor(secs / 60);
    const seconds = secs % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const [step, setStep] = useState("0");

  const [userDetails, setUserDetails] = useState([]);

  const [myProRes, setMyProRes] = useState([]);

  function valid(email) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
}
// const email = "example@domain.com";
// console.log(valid(email) ? "Valid email address" : "Invalid email address");

  const getMoblieOtp = (e) => {


    console.log(valid(ssoUserMobileNumber) ? "Valid email address" : "Invalid email address");

    e.preventDefault();
    dispatch({ type: loader.startLoader });

    // sendOtpMobile(ssoUserMobileNumber, (res) => {

    multipleUserOtp(ssoUserMobileNumber, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        setTimerStarted(true);
        setShowFinalButton(false);
        setSecondsLeft(180);
        setOtpBut("2");
        console.log(
          "res?.data?.result?.ssoUserDetails=",
          res?.data?.result?.ssoUserDetails?.length
        );

        if (res?.data?.result?.ssoUserDetails === null) {
          return;
        } else if (res?.data?.result?.ssoUserDetails?.length !== 0) {
          if (
            (res?.data?.result?.ssoUserDetails?.length === 1) &
            (res?.data?.result?.ssoUserDetails[0]?.userName !== null)
          ) {
            //CASE 1 In this case we have to redirect to dashboard.
            setUserId2(res?.data?.result?.ssoUserDetails[0]?.userName);

            setLoginByOtp("2");
          } else if (
            (res?.data?.result?.ssoUserDetails?.length === 1) &
            (res?.data?.result?.ssoUserDetails[0]?.userName === null)
          ) {
            //CASE 2 In this case we have to redirect to my profile.

            setStep("2");
            setMyProRes(res?.data?.result?.ssoUserDetails[0]);
          } else {
            //CASE 3 In this case we have to redirect to select user.
            setUserDetails(res?.data?.result?.ssoUserDetails);
            setStep("3");
          }
        }

        // if (res?.data?.result?.ssoUserDetails != null) {

        //   setUserId2(res?.data?.result?.ssoUserDetails?.userName)

        //   setLoginByOtp("2");
        // }

        toast.success(res?.data?.message);
      } else {
        toast.error(res?.data?.message);
      }
    });
  };

  const validateMobileOtp = (e) => {
    e.preventDefault();
    dispatch({ type: loader.startLoader });

    verifyMobileOtp(ssoUserMobileNumber, otp, (res) => {
      if (res?.data?.status) {
        //  toast.success("OTP is Successfully Validated")
        toast.success(res?.data?.message);
        dispatch({ type: loader.stopLoader });
        localStorage.setItem("moblie", ssoUserMobileNumber);

        if ((user === "0") & (step === "2")) {
          // console.log("USER CITIZEN");
          navigate("/myProfileRegister", {
            state: { mobNo: ssoUserMobileNumber, userData: myProRes },
          });
          window.location.reload();
        } else if ((user === "0") & (step === "3")) {
          // console.log("USER CITIZEN");
          navigate("/selectcitizenuser", {
            state: {
              mobNo: ssoUserMobileNumber,
              userDetail: userDetails,
              otp: otp,
            },
          });
          window.location.reload();
        } else if (user === "0") {
          // console.log("USER CITIZEN");
          navigate("/myprofile", { state: { mobNo: ssoUserMobileNumber } });
          window.location.reload();
        }

        if (user === "2") {
          // console.log("USER DEPT");
          navigate("/deptmyprofilr", { state: { mobNo: ssoUserMobileNumber } });
        }

        // navigate("/myprofile", { state: { mobNo: ssoUserMobileNumber } });
      } else {
        toast.error(res?.data?.message);

        // toast.error("Enter Correct OTP")
        dispatch({ type: loader.stopLoader });
      }
    });
  };

  // useEffect(() => {
  //   questions();
  // }, []);
  // const questions = () => {};

  const selectUser = (event) => {
    let inputValue = event.target.value;
    console.log("checkUSER=", inputValue);
    setUser(inputValue);
  };

  // const otpSent = () => {
  //   setOtpBut("2");
  // };
  const DDAotpSent = () => {
    console.log("AYA");
    setDDAOtp("2");
  };

  // const [seconds, setSeconds] = useState(30);

  return (
    <>


<div

style={{color:"white",height:"40px",backgroundColor:"grey"}}
>
<marquee><b>Important Notice:</b> Please note, Citizen login and registration across DDA Applications of Awaas, Bhoomi, Citizen Centric Services, Water Bill, Community Hall and Open space booking will be stopped by 01-August-2025. Please Sign up or login through SSO Portal.</marquee>
</div>

      <div className="row g-4 justify-content-around">

      <div className="col-lg-6 order-2 order-lg-1">
         

         {/* <img
                 src={HAND}
                 height="100px"
                 className="mt-4"
                 style={{ marginLeft: "39%" }}
               /> */}
     
       

         <br />
         <h3
           data-aos="fade-right"
           data-aos-duration="1000"
           className="aos-init aos-animate  mt-4"
           style={{ color: "white" }}
         >
           {t("welcomeHead")}
         </h3>
         <h2
           data-aos="fade-right"
           data-aos-duration="2000"
           className="aos-init aos-animate"
           style={{ color: "white" }}
         >
           {" "}
          eSevadawar Of DDA <br></br>( Single Sign On (SSO) Portal )
         </h2>
<br></br>
         <p
           data-aos="fade-right"
           data-aos-duration="2000"
           className="aos-init"
           style={{ color: "white" }}
         >
           {/* {t("information1")} */}


         <b>Now sign In through SARAL SSO Portal for the following Applications:</b>  <br></br>

           <ul>
  <li> <i class="fa fa-arrow-right" ></i>   eServices Application for housing and land schemes (Awaas and Bhoomi)</li>
  <li> <i class="fa fa-arrow-right" ></i>  Water Bill Online Payment System</li>
  <li> <i class="fa fa-arrow-right" ></i>  Online Measurement Book Filling System</li>
  <li> <i class="fa fa-arrow-right" ></i> OPD Mediclaim Reimbursement Application</li>
  <li><i class="fa fa-arrow-right" ></i> Citizen Centric Services of DDA</li>
</ul>  

{/* 1. eServices Application for housing and land schemes (Awaas and Bhoomi)<br></br>
2. Water Bill Online Payment System<br></br>
3. Online Measurement Book Filling System<br></br>
4. OPD Mediclaim Reimbursement Application<br></br>
5. Citizen Centric Services of DDA<br></br> */}


         </p>
       </div>
      




        <div
          className="col-lg-4 order-1 order-lg-2 hero-img aos-init aos-animate  "
          data-aos="zoom-out"
          data-aos-delay="300"
        >


          {/* {t("ab")} */}

          <div className="card shadow ">
            <div className="card-body maxHeight minHeight p-md-3">
              {/* radio button to the selct the user   */}
              {/* <h3 className="h2_heading">Delhi Development Authority</h3> */}

              <div></div>

              <div>
                <input
                  type="radio"
                  id="citizen1"
                  onClick={selectUser}
                  name="Dda"
                  value="0"
                />
                <label for="citizen1" className="marLeftR">
                  Citizen
                </label>

                <input
                  type="radio"
                  id="dda1"
                  onClick={selectUser}
                  name="Dda"
                  value="2"
                  className="marLeft"
                />
                <label for="dda1" className="marLeftR">
                  DDA Official
                </label>
              </div>

              {user === "0" ? (
                <>
                  {/* start for citizen user  */}
                  <br></br>

                  <Tabs
                    defaultActiveKey="loginbyotp"
                    id="justify-tab-example"
                    className="mb-3"
                    justify
                  >
                    <Tab eventKey="loginbyotp" title="Sign Up">
                      {/* start Registerfor new citizen */}
                      <form>
                        <div className="form-outline mb-4">
                          <label className="form-label" for="Enter Aadhaar">
                            Enter your Mobile Number/Email.
                          </label>

                          <input
                            type="text"
                            id="aadhaarcard"
                            onChange={(e) =>
                              setSsoUserMobilenumber(e.target.value)
                            }
                            className="form-control"
                            placeholder="Enter here"
                            // pattern="\d{10}"
                            // maxlength="10"
                            required
                            disabled={otpBut === "2" ? true : false}
                          />
                        </div>

                        {otpBut === "2" ? (
                          <>
                            <label className="form-label" for="Enter Aadhaar">
                              Enter OTP:
                            </label>
                            <div class="otp-container">
                              <OtpInput
                                value={otp}
                                onChange={setOtp}
                                numInputs={6}
                                renderSeparator={<span>-</span>}
                                renderInput={(props) => (
                                  <input class="otp-input " {...props} />
                                )}
                              />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}

                        {timerStarted && !showFinalButton && (
                          <b>Resend OTP after: {formatTime(secondsLeft)}</b>
                        )}

                        {showFinalButton && (
                          <button
                            type="button "
                            className="btn btn-primary w-100 mt-2"
                            onClick={getMoblieOtp}
                          >
                            Resend OTP
                          </button>
                        )}

                        {otpBut === "0" ? (
                          <button
                            type="button "
                            className="btn btn-primary w-100 mt-2"
                            onClick={getMoblieOtp}
                            // onClick={() => {
                            //   getMoblieOtp();
                            //   otpSent();
                            // }}
                          >
                            Send OTP
                          </button>
                        ) : loginByOtp === "2" ? (
                          <>
                            {" "}
                            <button
                              type="button "
                              className="btn btn-primary w-100 mt-2"
                              onClick={loginThroughOtp}
                            >
                              Verify OTP To Login
                            </button>
                          </>
                        ) : (
                          <button
                            type="button "
                            className="btn btn-primary w-100 mt-2"
                            onClick={validateMobileOtp}
                          >
                            Verify OTP
                          </button>
                        )}
                      </form>
                    </Tab>
                    <Tab eventKey="ssologin" title="Sign In">
                      {/* start login for already registerd user */}
                      <form>
                        <div className="form-outline mb-4">
                          <label className="form-label" for="Enter Aadhaar">
                            Username
                          </label>
                          <input
                            // value={ssoUserId}

                            onChange={(e) => setSsoUserId(e.target.value)}
                            type="text"
                            className="form-control"
                            placeholder="Enter here"
                          />
                        </div>

                        <div className="form-outline mb-4">
                          <label className="form-label" for="Enter Pass">
                            Password
                          </label>
                          <input
                            type="password"
                            onChange={(e) => setSsoUserPass(e.target.value)}
                            className="form-control"
                            placeholder="Enter your password"
                          />
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary w-100 mt-2"
                          onClick={submitSsoLogin}
                        >
                          Submit
                        </button>
                      </form>
                    </Tab>
                  </Tabs>
                </>
              ) : user === "2" ? (
                <>
                  {/* start for DDA officail */}

                  <Tabs
                    defaultActiveKey="SSO"
                    id="justify-tab-example"
                    className="mb-3"
                    justify
                  >
                    {/* <Tab eventKey="loginbyotp" title="Login By OTP">
                    <form>
                      <div className="form-outline mb-4">
                        <label className="form-label" for="Enter Aadhaar">
                          Enter your Mobile Number.
                        </label>
                        <input
                          type="mobile"
                          id="aadhaarcard"
                          className="form-control"
                          placeholder="Enter here"
                        />
                      </div>

                      {dDAOtp === "2" ? (
                        <>
                          <label className="form-label" for="Enter Aadhaar">
                            Enter OTP:
                          </label>
                          <div class="otp-container">
                            <OtpInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={6}
                              renderSeparator={<span>-</span>}
                              renderInput={(props) => (
                                <input class="otp-input " {...props} />
                              )}
                            />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}

                      {dDAOtp === "0" ? (
                        <button
                          type="button "
                          className="btn btn-primary w-100 mt-2"
                          
                          onClick={() => {
                            getMoblieOtp();
                            DDAotpSent();
                          }}
                        >
                          Send OTP
                        </button>
                      ) : (
                      
                        <button
                          type="button "
                          className="btn btn-primary w-100 mt-2"
                          onClick={validateMobileOtp}
                        >
                          Verify OTP
                        </button>
                      
                      )}
                    </form>
                  </Tab> */}
                    <Tab eventKey="SSO" title="SSO ">
                      <form>
                        <div className="form-outline mb-4">
                          <label className="form-label" for="Enter Aadhaar">
                            Username
                          </label>
                          <input
                            type="text"
                            onChange={(e) => setSsoDeptId(e.target.value)}
                            className="form-control"
                            placeholder="Enter here"
                          />
                        </div>

                        <div className="form-outline mb-4">
                          <label className="form-label" for="Enter Pass">
                            Password
                          </label>
                          <input
                            type="password"
                            onChange={(e) => setSsoDeptPass(e.target.value)}
                            className="form-control"
                            placeholder="Enter your password"
                          />
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary w-100 mt-2"
                          onClick={submitDepartmentSsoLogin}
                        >
                          Submit
                        </button>
                      </form>
                    </Tab>
                  </Tabs>
                </>
              ) : (
                <></>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
